// src/utils/constants.ts
export const APPS_SCRIPT_CONFIG = {
  appsScriptUrl: import.meta.env.VITE_GOOGLE_SCRIPT_COUNT_URL,
  autoUpdate: import.meta.env.VITE_AUTO_UPDATE === 'true',
  updateInterval: parseInt(import.meta.env.VITE_UPDATE_INTERVAL) || 300000,
  };
  
  export const DEFAULT_STATS = {
    orcamentosFechados: 1,
    percentualSatisfacao: 100,
    economiaMedia: 35,
    metrosQuadrados: 1000000,
  };